import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { BookOpen, Video, FileText, HelpCircle } from 'lucide-react';
export function ResourcesPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const resources = [{
    type: 'Guide',
    icon: BookOpen,
    title: 'The 2024 Restaurant Margin Playbook',
    description: 'Learn the 10 essential strategies top operators are using to combat inflation.'
  }, {
    type: 'Webinar',
    icon: Video,
    title: 'Mastering Food Cost Variance',
    description: 'Watch our deep dive into identifying and fixing profit leaks in your inventory.'
  }, {
    type: 'Case Study',
    icon: FileText,
    title: "How 'The Grill' Saved $12k in Labor",
    description: 'A detailed look at how one multi-unit group optimized their scheduling with ROI.'
  }, {
    type: 'FAQ',
    icon: HelpCircle,
    title: 'Platform Onboarding Guide',
    description: 'Everything you need to know about getting started with ROI in under 48 hours.'
  }];
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-stark-white" data-id="element-341">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-342" />

      <section className="pt-32 pb-20 bg-midnight-navy text-stark-white" data-id="element-343">
        <div className="max-w-7xl mx-auto px-6" data-id="element-344">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-345">
            <h1 className="text-5xl md:text-6xl font-manrope font-bold mb-6" data-id="element-346">
              Resources
            </h1>
            <p className="text-xl text-stark-white/70 leading-relaxed" data-id="element-347">
              Insights, guides, and tools to help you run a more profitable
              restaurant.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24" data-id="element-348">
        <div className="max-w-7xl mx-auto px-6" data-id="element-349">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-350">
            {resources.map((resource, idx) => <motion.div key={resource.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="group p-8 bg-stark-white border border-gray-200 rounded-2xl hover:border-accent-red hover:shadow-xl transition-all cursor-pointer" data-id="element-351">
                <div className="flex justify-between items-start mb-6" data-id="element-352">
                  <div className="w-12 h-12 bg-cool-gray rounded-xl flex items-center justify-center group-hover:bg-accent-red group-hover:text-stark-white transition-colors" data-id="element-353">
                    <resource.icon className="w-6 h-6" data-id="element-354" />
                  </div>
                  <span className="text-xs font-bold uppercase tracking-widest text-accent-red" data-id="element-355">
                    {resource.type}
                  </span>
                </div>
                <h3 className="text-2xl font-manrope font-bold text-midnight-navy mb-3 group-hover:text-accent-red transition-colors" data-id="element-356">
                  {resource.title}
                </h3>
                <p className="text-midnight-navy/60 leading-relaxed" data-id="element-357">
                  {resource.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-358" />
      <Footer data-id="element-359" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-360" />
    </motion.main>;
}